import Vue from 'vue';
import Main from './main.vue';

const ConfirmConstructor = Vue.extend(Main);

function Confirm(title = '', content = '', opts = {}) {
  return new Promise((resolve, reject) => {
    const instance = new ConfirmConstructor({
      data: {
        ...opts,
        title,
        content,
      },
    });
    instance.$mount();
    document.body.appendChild(instance.$el);
    instance.show(resolve, reject);
  }).catch((error) => error);
}

export default Confirm;
